import {BaseActionFunctionParameters} from 'notebook/structured-tables/StructuredTableConstants';
import {AnyStructuredTable} from 'notebook/util/NoteUtilConstants';
import APIUtil from 'util/APIUtil';

/**
 * Returns true if the action is being performed in an executable canvas (entry or executable document)
 * @param actionFunctionParams
 * @returns boolean indicating if the action is being performed in an executable canvas
 */
export function isInExecutableCanvas<TTableMetadata, TRowMetadata>(
  actionFunctionParams:
    | {
        entryOrTemplateId?: string | null;
        structuredTable: AnyStructuredTable;
      }
    | Pick<
        BaseActionFunctionParameters<TTableMetadata, TRowMetadata>,
        'entryOrTemplateId' | 'structuredTable'
      >
): boolean {
  return (
    actionFunctionParams.entryOrTemplateId == null ||
    APIUtil.isEntry(actionFunctionParams.entryOrTemplateId) ||
    (APIUtil.isDocument(actionFunctionParams.entryOrTemplateId) &&
      !actionFunctionParams.structuredTable.isConfig)
  );
}
